<template>
    <p>
        {{getLocalizedText()}}
    </p>
</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'cancellationpolicy',
    	props: {
    		policy: Object,
    		from: String,
    		translation: {
    			type: String,
    			//default: 'Kostenlose Stornierung bis __DAYS__ Tage vor Anreise'
    			default: 'Sorgfältig vorbereitet – sauber & bezugsfertig'
    		},
    		translationdate: {
    			type: String,
    			default: 'Bis zum __DATE__ kostenlos stornierbar - sorgenfrei buchen'
    		}

    	},
    	data: function() {
    		return {
    			showDate: false,
    			showGeneral: true
    		};
    	},
    	computed: {

    		maxDaysBeforeArrival() {
    				if (!this.policy || !this.policy.byDaysTillArrival) {
    					return null;
    				}
    				return Math.max(...this.policy.byDaysTillArrival.map(p => p.daysBeforeArrival));
    			},
    			/*localizedText() {
    				if (this.showDate) {
    					const today = DateEx.interfaceFormat(DateEx.getToday());
    					let diff = DateEx.getDays(this.from, today);
    					if (diff < (this.maxDaysBeforeArrival + 1)) {
    						this.showDate = false;
    					} else {
    						const date = new Date(this.from);
    						date.setDate(date.getDate() - (this.maxDaysBeforeArrival));
    						let lastDay = DateEx.formatDate(date.toISOString().split("T")[0], VOFFICE.mlang);
    						console.log('with date translation:::' + this.translationdate.replace('__DATE__', lastDay));
    						return this.translationdate.replace('__DATE__', lastDay);
    					}

    				} else {
    					console.log('with days translation:::' + this.translation.replace('__DAYS__', (this.maxDaysBeforeArrival + 1)));
    					return this.translation.replace('__DAYS__', (this.maxDaysBeforeArrival + 1));
    				}
    			}*/

    	},

    	methods: {
    		getLocalizedText: function() {
    			if (this.showDate) {
    				const today = DateEx.interfaceFormat(DateEx.getToday());
    				let diff = DateEx.getDays(this.from, today);
    				if (diff < (this.maxDaysBeforeArrival + 1)) {
    					this.showDate = false;
    				} else {
    					const date = new Date(this.from);
    					date.setDate(date.getDate() - (this.maxDaysBeforeArrival));
    					let lastDay = DateEx.formatDate(date.toISOString().split("T")[0], VOFFICE.mlang);
    					return this.translationdate.replace('__DATE__', lastDay);
    				}

    			} else {
    				return this.translation.replace('__DAYS__', (this.maxDaysBeforeArrival + 1));
    			}
    		}
    	},

    	mounted: function() {

    		//console.log('Policy::', this.policy);

    		if (this.policy && this.policy.byDaysTillArrival && !this.policy.defaultPenalty && !this.policy.cancellationFlatFee) {
    			if (this.from) {
    				this.showDate = true;
    				this.showGeneral = false;
    			}
    		} else {
    			this.showGeneral = true;
    		}
    	}

    };
</script>